/** Default bundle shown when choosing Regular vs Organic on select. */
export function getDefaultBundlePricing(plan) {
  if (!plan?.pricing?.length) return null;
  return plan.pricing.find((row) => row.bundle === 'Complete Meal')
    || plan.pricing.find((row) => row.bundle === 'Complete weekly plan')
    || plan.pricing[0];
}

export function formatPlanPrice(value) {
  if (value == null || Number.isNaN(value)) return '—';
  return `₹${Number(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Whole rupees for select popup totals (matches design mockup). */
export function formatPlanPriceWhole(value) {
  if (value == null || Number.isNaN(value)) return '—';
  return `₹${Number(value).toLocaleString('en-IN')}`;
}
